module.exports = __webpack_public_path__ + "static/session-abfc6ed1c3b09899b05dd88b8f945897.png";